import { type HTMLAttributes, type PropsWithChildren } from "react"
import { useCoralDropdown } from "@octopus-energy/coral/atoms"

type DropdownZoneProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>>

export function DropdownZone({ children, ...props }: DropdownZoneProps) {
    const { openDropdown, closeDropdown } = useCoralDropdown()

    return (
        <div
            onMouseEnter={openDropdown}
            onMouseLeave={closeDropdown}
            onFocus={openDropdown}
            onBlur={closeDropdown}
            {...props}
        >
            {children}
        </div>
    )
}
